import { connect } from 'react-redux';
import Product from './Product';

export default connect(state => state.ProductState)(Product);



/** WEBPACK FOOTER **
 ** ./apps/maptool/modules/Product/ProductContainer.js
 **/